
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","d":"M19.14 10.94a.5.5 0 010 .71l-.2.2a.488.488 0 01-.36.15H15v7.5a.5.5 0 01-.5.5h-5a.5.5 0 01-.5-.5V12H5.42a.488.488 0 01-.36-.15l-.2-.2a.5.5 0 010-.71l6.79-6.79a.477.477 0 01.7 0l6.79 6.79z"}})])
          )
        }
      }
    